/* Toggle switch — pill-shaped ON/OFF button */

.track {
  display: flex;
  align-items: center;
  min-width: 32px;
  height: 20px;
  padding: 2px;
  border: none;
  border-radius: var(--radius\/3xl, 360px);
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  outline: none;
}

.track:focus-visible {
  outline: 2px solid var(--color\/text\/link-default, #75adfc);
  outline-offset: 1px;
}

/* ON state — link-default blue bg, thumb right */
.on {
  background-color: var(--color\/text\/link-default, #75adfc);
  justify-content: flex-end;
  border: 2px solid transparent;
}

/* OFF state — grey border, thumb left */
.off {
  background-color: transparent;
  justify-content: flex-start;
  border: 2px solid var(--color\/button\/button-disabled, #656871);
}

.on:hover {
  background-color: #4F98FF;
}

.off:hover {
  border-color: var(--color\/text\/text-secondary, #bababa);
}

.off:hover .thumb {
  background-color: var(--color\/text\/text-primary, #fff);
}

.thumb {
  display: block;
  width: 12px;
  height: 12px;
  border-radius: var(--radius\/3xl, 360px);
  flex-shrink: 0;
}

.on .thumb {
  background-color: var(--color\/text\/text-primary, #fff);
}

.off .thumb {
  background-color: var(--color\/text\/text-secondary, #bababa);
}
